<template>
  <v-layout wrap>
    <v-flex xs12>
      <AppForm label="配信対象クラスター" />
    </v-flex>
    <v-flex xs8 offset-xs1>
      <AppTwoColumnsSelector
        :items="clusters"
        :value="menuSetting.clusterIds"
        :is-show-all-select="true"
        @changeChosenItems="menuSetting.clusterIds = $event"
        available-label="クラスター一覧"
        chosen-label="配信対象クラスター"
        item-value="id"
      />
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="対象地域" />
    </v-flex>
    <v-flex xs8 offset-xs1>
      <AppTwoColumnsSelector
        :items="broadCategoryList"
        :value="menuSetting.prefecture"
        :is-show-all-select="true"
        @changeChosenItems="menuSetting.prefecture = $event"
        available-label="都道府県一覧"
        chosen-label="配信対象地域"
        item-value="id"
      />
    </v-flex>
    <v-flex xs12 mt-3>
      <AppForm label="備考" />
    </v-flex>
    <v-flex xs10 mt-1 offset-xs1>
      <v-textarea v-model="menuSetting.memo" outline />
    </v-flex>
  </v-layout>
</template>

<script>
import { MasterRepository } from '@/models/Master/MasterRepository'
import { Clusters } from '@/models/Menu/Constants'
export default {
  name: 'CampaignModalGeoGenome',
  props: {
    form: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      prefectureList: [],
      clusters: Clusters,
    }
  },
  computed: {
    broadCategoryList() {
      return this.prefectureList.map(prefecture => {
        const isChosen =
          this.menuSetting.prefecture.indexOf(prefecture.id) !== -1
        return this.makeItem(prefecture, isChosen)
      })
    },
    menuSetting() {
      return this.form.campaign.menuSetting.orderDescription
    },
    errorMessage() {
      const errorMessages = []
      if (this.menuSetting.clusterIds.length === 0) {
        errorMessages.push('配信対象クラスターを指定してください')
      }
      if (this.menuSetting.prefecture.length === 0) {
        errorMessages.push('対象地域を指定してください')
      }
      return errorMessages.length === 0 ? '' : errorMessages
    },
  },
  watch: {
    'menuSetting.clusterIds'(val) {
      this.form.campaign.menuSetting.clusterIdAndNames = this.clusters.filter(
        cluster => val.indexOf(cluster.id) !== -1,
      )
    },
    'menuSetting.prefecture'(val) {
      this.form.campaign.menuSetting.prefectureIdAndNames = this.prefectureList.filter(
        prefecture => val.indexOf(prefecture.id) !== -1,
      )
    },
  },
  async created() {
    await this.fetchPrefectureList()
  },
  methods: {
    async fetchPrefectureList() {
      this.prefectureList = await MasterRepository.fetchPrefectureList({
        countryId: 1, // 日本のcountryIdは1
      })
    },
    makeItem(item, isChosen) {
      return {
        id: item.id,
        name: item.name,
        selected: false,
        chosen: isChosen,
      }
    },
  },
}
</script>

<style scoped>
.v-textarea >>> textarea {
  margin-top: 0;
}
</style>
